<template>
  <v-card class="rounded-xl repair-file-finalized" :border="false" :elevation="0"
          @click="redirectToReport()">
    <v-row>
      <v-col cols="5" class="text-content">
        <p class="text">{{ $t('DASHBOARD.REPAIR_FILE_FINALIZED.TITLE') }}</p>
      </v-col>
      <v-col cols="4" class="number-content">
        <p class="number">{{ $t('DASHBOARD.REPAIR_FILE_FINALIZED.CO2') }}</p>
      </v-col>
      <v-col cols="3" class="d-flex justify-center align-center">
        <div class="eco-logo">
          <img class="eco-img" src="@/assets/icons/dashboard/world.png" alt="icon eco-world"/>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import RepairFileService from '@/services/RepairFileService';

export default {
  name: 'RepairFileFinalized',
  data() {
    return {
      repairFilePercentage: '-'
    }
  },
  async created() {
    try {
      const response = await RepairFileService.getRepairFileFinalizedPercent()
      this.repairFilePercentage = response.repair_file_percentage
    } catch (error) { /* empty */
    }
  },
  methods: {
    redirectToReport() {
      this.$router.push({ name: 'RecyclingReportPage' })
    }
  }
}

</script>

<style scoped>
.v-card {
  padding: 20px !important;
}

.repair-file-finalized {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
}

.text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.eco-logo {
  display: flex;
  width: 70px;
  height: 70px;
  padding: 20px;
  border: unset;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
}

.eco-img {
  width: 70px;
}

.number {
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  align-items: center;
}

.number-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 170px;
}

.text-content {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100px;
}
</style>
